export const LeaveTypesList = ['Carry Forward', 'Casual'];
export const LEAVE_TYPE_LABEL = 'Leave Type';
export const SUBJECT_LABEL = 'To';
export const SUBJECT_PLACEHOLDER = 'To';
export const NO_SUBJECT_ERROR_LABEL =
  'Manager not assigned : Application cannot be processed. Please contact the Admin department.';
export const EMPLOYEE = 'Employee';
export const CASUAL_LEAVE = 'CASUAL_LEAVE';
export const SICK_LEAVE = 'SICK_LEAVE';
export const MISCELLANEOUS_LEAVE = 'MISCELLANEOUS_LEAVE';
export const WFH = 'WFH';
export const Is_Updated_By_HR = 'Updated by HR';
export const LEAVE_STATUS_LABEL = 'Leave Status';
export const WFH_STATUS_LABEL = 'WFH Status';
export const APPROVED = 'APPROVED';
export const REJECTED = 'REJECTED';
export const PENDING = 'PENDING';
export const CANCELLED = 'CANCELLED';
export const NO_LEAVES = 'No Leaves..';
export const NO_LEAVE_SUMMARY = 'No summary available..';

export const leaveType = (leaveType) => {
  if (leaveType === 'CASUAL_LEAVE') return 'Casual Leave';
  else if (leaveType === 'WFH') return 'Work from home';
  else if (leaveType === 'SICK_LEAVE') return 'Sick Leave';
  else if (leaveType === 'MISCELLANEOUS_LEAVE') return 'Misc. Leave';
  return leaveType;
};

export const leaveStatus = (status) => {
  if (status === 'APPROVED') return 'Approved';
  else if (status === 'PENDING') return 'Pending';
  else if (status === 'REJECTED') return 'Rejected';
  else if (status === 'CANCELLED') return 'Cancelled';
  return status;
};

export const LeavesPieData = [
  {
    id: 'casual',
    label: 'Casual',
    value: 6,
    color: 'hsl(250, 70%, 50%)',
  },
  {
    id: 'used',
    label: 'Leaves Used',
    value: 6,
    color: 'hsl(244, 70%, 50%)',
  },
  {
    id: 'carry',
    label: 'Carry Forward',
    value: 6,
    color: 'hsl(97, 70%, 50%)',
  },
];
